import { render, staticRenderFns } from "./LayoutError.vue?vue&type=template&id=83457e4c&"
import script from "./LayoutError.vue?vue&type=script&lang=js&"
export * from "./LayoutError.vue?vue&type=script&lang=js&"
import style0 from "./LayoutError.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports